import { Card } from '@mui/material'
import { useEffect, useState } from 'react'
import { ListDisplay } from '../../Component/ListDisplay/ListDisplay'
import { useStore } from 'react-redux'
import { useParams } from 'react-router-dom'
import { constants as cons } from '../../Constants/constants'
import _ from 'lodash'
import { getList } from '../../helper/baseFetch'
import { generateTableCellToMultiLanguageName as generateNameTableCellToMultiLanguageName } from '../../helper/util'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'

export const PickupSoundTemplateList = ({ createBtn, editBtn, onClickListRow, newListTitles, newListFilters }) => {
  const store = useStore()
  const params = useParams()

  const resource = 'SoundTemplate'

  const [soundTemplateList, setSoundTemplateList] = useState([])
  const [ready, setReady] = useState(false)
  const [clear, setClear] = useState(false)

  const listTitles = newListTitles || [
    {
      key: cons.LIST_DISPLAY_TYPE.ICON,
      value: 'showSoundIcon',
      icon: <VolumeUpIcon />,
      sort: false,
    },
    {
      key: cons.LIST_DISPLAY_TYPE.STRING,
      value: 'code',
      sort: false,
    },
    {
      key: cons.LIST_DISPLAY_TYPE.STRING,
      value: 'soundTemplateCode',
      sort: false,
    },
    {
      key: cons.LIST_DISPLAY_TYPE.STRING,
      value: 'name',
      sort: false,
    },
    {
      key: cons.LIST_DISPLAY_TYPE.STRING,
      value: 'status',
      sort: true,
    },
  ]

  const listFilters = newListFilters || [
    {
      className: 'filter-input',
      label: { resource: resource, key: 'name' },
      clear: true,
      value: '',
      name: 'name',
    },
    {
      className: 'filter-input',
      label: { resource: resource, key: 'status' },
      clear: true,
      value: '',
      name: 'status',
    },
  ]

  const [filterOption, setFilterOption] = useState({
    path: '',
    page: 0,
    rowsPerPage: 10,
    sort: 'updateTimestamp',
    direction: 'DESC',
    listFilters: listFilters,
    count: 0,
  })

  const onChangeFilterOption = (filterOption) => {
    setFilterOption({ ...filterOption, count: filterOption.count + 1 })
  }

  const onChangeListFilters = (listFilters) => {
    onChangeFilterOption({ ...filterOption, listFilters: listFilters, page: 0 })
  }

  const onChangeListSort = (sort) => {
    onChangeFilterOption({ ...filterOption, sort: sort, direction: filterOption.direction === 'DESC' ? 'ASC' : 'DESC' })
  }

  const onChangeListPage = (page) => {
    onChangeFilterOption({ ...filterOption, page: page })
  }

  const onChangeListRowsPerPage = (rowsPerPage) => {
    onChangeFilterOption({ ...filterOption, page: 0, rowsPerPage: rowsPerPage })
  }

  useEffect(() => {
    let newFilterOption = _.cloneDeep(filterOption)
    const newFilter = {}

    newFilterOption.listFilters.forEach((item) => {
      if (item.value !== '' && item.value !== undefined) {
        newFilter[item.name] = item.value
      }
    })

    getList(
      cons.PATH.SHOP.PICKUP.PICKUP_TEMPLATE,
      {
        sort: { field: newFilterOption.sort, order: newFilterOption.direction },
        filter: newFilter,
        pagination: { page: newFilterOption.page + 1, perPage: newFilterOption.rowsPerPage },
      },
      (payload) => {
        // console.log('payload', payload)
        payload.forEach((item) => {
          item.name = generateNameTableCellToMultiLanguageName(item.tcName, item.enName, item.scName)
          item.showSoundIcon = !!item.soundTemplateCode
        })
        setSoundTemplateList(payload)
        setReady(true)
        setClear(false)
      },
      undefined,
      store
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOption.count, clear === true])

  // useEffect(() => {
  //   console.log('soundTemplateList', soundTemplateList)
  // }, [soundTemplateList])

  return (
    ready && (
      <>
        <Card className="card-wrapper overflow">
          <ListDisplay
            page={filterOption.page}
            rowsPerPage={filterOption.rowsPerPage}
            onChangeListSort={onChangeListSort}
            resource={resource}
            dataList={soundTemplateList}
            sort={filterOption.sort}
            direction={filterOption.direction}
            listTitles={listTitles}
            listFilters={filterOption.listFilters}
            onChangeListPage={onChangeListPage}
            onChangeListRowsPerPage={onChangeListRowsPerPage}
            idParam={params.id}
            onChangeListFilters={onChangeListFilters}
            redirectPath={'/' + cons.PATH.MERCHANT.COUNTER + '/'}
            createBtn={createBtn}
            editBtn={editBtn}
            onClickListRow={onClickListRow}
            idName="id"
          />
        </Card>
      </>
    )
  )
}
